/** Public config only (spec Appendix C) — injected by @studyward/config/public-env. Secrets never reach the bundle. */
export const env = {
  supabaseUrl: import.meta.env.PUBLIC_SUPABASE_URL as string,
  supabaseAnonKey: import.meta.env.PUBLIC_SUPABASE_ANON_KEY as string,
  appUrl: (import.meta.env.PUBLIC_APP_URL as string) || "http://localhost:5173",
};

export const isConfigured = Boolean(env.supabaseUrl && env.supabaseAnonKey);
export const apiBaseUrl = `${env.supabaseUrl}/functions/v1/api/v1`;
